if (!customElements.get('glamlax-shade-preview')) {
  customElements.define('glamlax-shade-preview', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.loading) return;
      this.dataset.loading = 'true';
      try {
        const destination = new URL(this.dataset.url, location.origin);
        if (destination.origin !== location.origin) return;
        destination.searchParams.set('variant', this.dataset.variant);
        const endpoint = new URL(destination);
        endpoint.searchParams.set('section_id', 'glamlax-shade-preview');
        let response = await fetch(endpoint);
        if (!response.ok) throw new Error('Preview unavailable');
        let doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (this.dataset.shade) {
          const variants = JSON.parse(doc.querySelector('[data-shade-variants]').textContent);
          const variant = variants.find(item => item.title === this.dataset.shade);
          if (!variant) throw new Error('Shade not found');
          destination.searchParams.set('variant', variant.id);
          endpoint.searchParams.set('variant', variant.id);
          response = await fetch(endpoint);
          if (!response.ok) throw new Error('Preview unavailable');
          doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        }
        const card = doc.querySelector('.card-wrapper');
        if (!card) throw new Error('Missing shade card');
        card.querySelectorAll('a[href]').forEach(link => { link.href = destination.href; });
        card.querySelectorAll('[id],[aria-labelledby]').forEach(node => {
          for (const attr of ['id','aria-labelledby']) {
            if (node.hasAttribute(attr)) node.setAttribute(attr, node.getAttribute(attr).replaceAll('glamlax-shade-preview', this.dataset.key));
          }
        });
        if (this.dataset.image) {
          const image = card.querySelector('.card__media img');
          image.src = this.dataset.image;
          image.removeAttribute('srcset');
        }
        this.replaceWith(card);
      } catch (error) {
        this.dataset.loading = 'failed';
      }
    }
  });
}
if (!customElements.get('glamlax-shade-carousel')) {
  customElements.define('glamlax-shade-carousel', class extends HTMLElement {
    async connectedCallback() {
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.touching = false;
      this.delay = Math.max(3000, Number(this.dataset.interval) || 4000);
      await customElements.whenDefined('slider-component');
      if (!this.isConnected) return;
      this.component = this.querySelector('slider-component');
      this.track = this.querySelector('[id^="Slider-"]');
      this.component.enableSliderLooping = true;
      const listen = (target, type, fn, extra = {}) => target.addEventListener(type, fn, { signal: this.abort.signal, ...extra });
      this.querySelectorAll('.slider-button').forEach(button => {
        button.disabled = false;
        listen(button, 'click', event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.advance(button.name === 'next' ? 1 : -1);
          this.schedule();
        }, { capture: true });
      });
      listen(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      listen(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      listen(this, 'pointerdown', () => { this.touching = true; this.schedule(); });
      listen(window, 'pointerup', () => { this.touching = false; this.schedule(); });
      listen(window, 'pointercancel', () => { this.touching = false; this.schedule(); });
      listen(this.track, 'wheel', () => this.schedule(), { passive: true });
      listen(this.track, 'scroll', () => this.schedule(), { passive: true });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => this.schedule());
      listen(document, 'shopify:block:select', event => { if (this.contains(event.target)) { this.focused = true; this.schedule(); } });
      listen(document, 'shopify:block:deselect', () => { this.focused = false; this.schedule(); });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.25 });
      this.observer.observe(this);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const running = this.dataset.autoplay === 'true' && this.visible && !document.hidden && !this.motion.matches && !this.hovered && !this.focused && !this.touching;
      this.dataset.playing = String(running);
      if (running) this.timer = setTimeout(() => { this.advance(1); this.schedule(); }, this.delay);
    }
    advance(direction) {
      const items = this.track.querySelectorAll('[id^="Slide-"]');
      if (items.length < 2) return;
      const step = items[1].offsetLeft - items[0].offsetLeft;
      const end = this.track.scrollWidth - this.track.clientWidth;
      let next = this.track.scrollLeft + step * direction;
      if (direction > 0 && this.track.scrollLeft >= end - 2) next = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) next = end;
      this.track.scrollTo({left:Math.max(0,Math.min(end,next)),behavior:this.motion.matches?'instant':'smooth'});
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
